import React from 'react';
import { LockKeyhole, Mail, UserCheck } from 'lucide-react';

const privacySections = [
  {
    title: 'Datos personales que podemos recabar',
    body: 'Podemos recabar datos de identificación, contacto, ubicación, referencias, información laboral, información financiera y documentos necesarios para evaluar, contactar o dar seguimiento a solicitudes de crédito.'
  },
  {
    title: 'Finalidades del tratamiento',
    body: 'Utilizamos los datos personales para atender solicitudes de información, evaluar posibles créditos, validar identidad, contactar al solicitante, dar seguimiento a servicios contratados, cumplir obligaciones legales y mantener registros administrativos.'
  },
  {
    title: 'Finalidades secundarias',
    body: 'También podremos utilizar tus datos para enviar información promocional, encuestas de satisfacción, recordatorios, noticias o comunicaciones relacionadas con servicios de PrestaNet. Puedes oponerte a estas finalidades por correo electrónico.'
  },
  {
    title: 'Transferencias',
    body: 'Los datos personales podran compartirse con proveedores de servicios, asesores, autoridades competentes o terceros necesarios para cumplir obligaciones legales, contractuales u operativas relacionadas con los servicios solicitados.'
  },
  {
    title: 'Derechos ARCO',
    body: 'Puedes solicitar el acceso, rectificación, cancelación u oposicion al tratamiento de tus datos personales, así cómo revocar tu consentimiento, enviando una solicitud al correo indicado en este aviso.'
  },
  {
    title: 'Seguridad de la información',
    body: 'El responsable implementa medidas administrativas, técnicas y físicas razonables para proteger los datos personales contra daño, pérdida, alteración, destrucción, uso, acceso o tratamiento no autorizado.'
  },
  {
    title: 'Cambios al aviso de privacidad',
    body: 'Cualquier modificación a este aviso de privacidad sera publicada en esta misma pagina para que puedas consultar la versión vigente.'
  }
];

export const Privacy = () => {
  return (
    <main className="min-h-screen bg-slate-50 pt-28">
      <section className="bg-gradient-to-br from-emerald-900 via-slate-900 to-slate-800 px-4 py-16 text-white">
        <div className="container mx-auto max-w-5xl">
          <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-400 text-slate-950 shadow-lg">
            <LockKeyhole size={28} />
          </div>
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-emerald-200">
            Protección de datos personales
          </p>
          <h1 className="text-4xl font-bold leading-tight md:text-6xl">
            Aviso de privacidad
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-slate-200">
            Este aviso explica cómo PrestaNet puede recabar, usar y proteger los datos personales proporcionados por usuarios, solicitantes y clientes.
          </p>
        </div>
      </section>

      <section className="px-4 py-14">
        <div className="container mx-auto max-w-5xl">
          <div className="mb-8 rounded-lg border border-emerald-200 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center gap-3 text-slate-900">
              <UserCheck className="text-emerald-600" size={24} />
              <h2 className="text-2xl font-bold">Responsable del tratamiento</h2>
            </div>
            <p className="text-slate-700 leading-relaxed">
              <strong>LUIS GUSTAVO VACA DINGFELDER</strong> (RFC:{' '}
              <strong>VADL730823B69</strong>), operador del sitio{' '}
              <strong>prestanet.com.mx</strong>, es responsable del tratamiento de los datos personales recabados a través de este sitio, formularios, canales de contacto y medios de atención relacionados con PrestaNet.
            </p>
          </div>

          <div className="grid gap-5">
            {privacySections.map((section) => (
              <article key={section.title} className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
                <h2 className="mb-3 text-xl font-bold text-slate-900">{section.title}</h2>
                <p className="leading-relaxed text-slate-600">{section.body}</p>
              </article>
            ))}
          </div>

          <div className="mt-8 rounded-lg bg-slate-900 p-6 text-slate-200">
            <div className="mb-3 flex items-center gap-3">
              <Mail className="text-amber-300" size={22} />
              <h2 className="text-xl font-bold text-white">Medio de contacto</h2>
            </div>
            <p className="leading-relaxed">
              Para ejercer derechos ARCO, revocar consentimiento, limitar el uso de tus datos o realizar preguntas sobre este aviso, escribe a{' '}
              <a className="font-semibold text-amber-300 hover:text-amber-200" href="mailto:quierocrédito@prestanet.com.mx">
                quierocrédito@prestanet.com.mx
              </a>.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Privacy;
